import axios from "axios";

let pendingBooking = null;

// All paid event gateways use the same booking payload and completion path.
export const completeEventBooking = (baseUrl, transactionId) => {
  if (pendingBooking) return pendingBooking;
  if (sessionStorage.getItem("pages") !== "booking") return Promise.resolve(null);

  pendingBooking = (async () => {
    const event = JSON.parse(sessionStorage.getItem("EventData") || "null");
    const checkout = JSON.parse(sessionStorage.getItem("EventCheckout") || "null");
    const userId = localStorage.getItem("Userid");
    const paymentId = sessionStorage.getItem("Paymentid");
    if (!event?.Eventid || checkout?.eventId !== event.Eventid || !userId || !paymentId || !transactionId) {
      throw new Error("Booking details or payment reference are missing. Please contact support before paying again.");
    }
    const response = await axios.post(`${baseUrl}user_api/book_ticket.php`, {
      uid: userId,
      eid: event.Eventid,
      typeid: event.Typeid,
      type: event.Type,
      price: event.Singleprice,
      total_ticket: event.con,
      subtotal: event.Totalprice,
      tax: event.Tax,
      cou_amt: checkout.couponAmount ?? 0,
      total_amt: checkout.total,
      wall_amt: checkout.walletAmount ?? 0,
      p_method_id: paymentId,
      transaction_id: transactionId,
      plimit: event.plimit,
      sponsore_id: event.Sponsoreid || "0",
    });
    if (String(response.data?.ResponseCode) !== "200") {
      throw new Error(response.data?.ResponseMsg || "Ticket booking failed. Please retry booking without paying again.");
    }
    ["EventData", "EventCheckout", "pages", "Amount", "Paymentstatus"]
      .forEach((key) => sessionStorage.removeItem(key));
    return response.data;
  })().finally(() => { pendingBooking = null; });
  return pendingBooking;
};
